import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
var TextLineMirrorRegion = /** @class */ (function (_super) {
    __extends(TextLineMirrorRegion, _super);
    function TextLineMirrorRegion() {
        var _this = _super.call(this) || this;
        console.warn('[TextLineMirrorRegion] not implemented');
        return _this;
    }
    Object.defineProperty(TextLineMirrorRegion.prototype, "textLine", {
        // JS -> AS Bindings
        // AS -> JS Bindings
        // _textLine: flash.text.engine.TextLine;
        // _nextRegion: flash.text.engine.TextLineMirrorRegion;
        // _previousRegion: flash.text.engine.TextLineMirrorRegion;
        // _mirror: flash.events.EventDispatcher;
        // _element: flash.text.engine.ContentElement;
        // _bounds: flash.geom.Rectangle;
        get: function () {
            console.warn('[TextLineMirrorRegion] - get textLine not implemented');
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextLineMirrorRegion.prototype, "nextRegion", {
        get: function () {
            console.warn('[TextLineMirrorRegion] - get nextRegion not implemented');
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextLineMirrorRegion.prototype, "previousRegion", {
        get: function () {
            console.warn('[TextLineMirrorRegion] - get previousRegion not implemented');
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextLineMirrorRegion.prototype, "mirror", {
        get: function () {
            console.warn('[TextLineMirrorRegion] - get mirror not implemented');
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextLineMirrorRegion.prototype, "element", {
        get: function () {
            console.warn('[TextLineMirrorRegion] - get element not implemented');
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextLineMirrorRegion.prototype, "bounds", {
        get: function () {
            console.warn('[TextLineMirrorRegion] - get bounds not implemented');
            return null;
        },
        enumerable: true,
        configurable: true
    });
    TextLineMirrorRegion.forceNativeConstructor = true;
    TextLineMirrorRegion.forceNativeMethods = true;
    return TextLineMirrorRegion;
}(ASObject));
export { TextLineMirrorRegion };
